import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { TrendingUp } from "lucide-react";

export function AdhikaraCard({ adhikara }) {
  if (!adhikara) return null;
  return (
    <Card className="bg-white/90 shadow-card" data-testid="journey-adhikara-card">
      <CardHeader className="pb-2">
        <CardTitle className="text-base flex items-center gap-2">
          <TrendingUp className="w-4 h-4 text-primary" />
          Adhikāra
        </CardTitle>
      </CardHeader>
      <CardContent className="text-sm space-y-1">
        <p className="font-medium">{adhikara.name}</p>
        {adhikara.title && <p className="text-muted-foreground">{adhikara.title}</p>}
        {adhikara.description && <p className="text-xs text-muted-foreground">{adhikara.description}</p>}
      </CardContent>
    </Card>
  );
}
